module.exports = __webpack_public_path__ + "static/hse-video-poster-b6723132b63b3f45d0ade793ebfa7d91.png";